// Ported from packages/workflow-engine-upstream/ui/src/conversation-text.ts at commit bebc382; only imports changed.
// The conversation column's text, apart from React so it can be tested: one line for each run
// event, and what an ask's answer box shows.
import type { Ask, RunEvent, RunState } from './api';

/** The line a run event adds to the conversation, or null for an event that adds none. */
export function eventLine(e: RunEvent, s: RunState): string | null {
  const reason = e.payload?.reason ? ` (${String(e.payload.reason)})` : '';
  switch (e.type) {
    case 'resumed':
      return e.stepId ? 'Answered. Continuing the run.' : 'Answered.';
    case 'plan_proposed': {
      const src = s.trace.planVersions.find((p) => p.version === e.planVersion)?.source;
      const from = e.payload?.card ? 'worked out from the data, part by part' : src?.kind === 'catalog' ? `from ${src.procedureId}` : src?.kind === 'file' ? 'from the supplied file' : src?.kind === 'interview' ? 'from the interview' : src?.kind === 'question' ? 'from your steps' : 'worked out from the data';
      return `Plan v${e.planVersion} is ready, ${from}. Approve it in the plan.`;
    }
    case 'replanned': {
      const at = e.stepId ? ` at step ${e.stepId}` : '';
      return `Re-planned${at}${reason}. Steps already done are kept.`;
    }
    case 'plan_approved':
      return `Approved v${e.planVersion}. Running the plan.`;
    case 'step_parked':
      // A step parks for a tool that failed (its outcome) or for something only the user can give (an ask).
      return e.payload?.outcome
        ? `Step ${e.stepId} stopped: its read came back ${String(e.payload.outcome)}${reason}.`
        : `Step ${e.stepId} needs an answer from you (see the ask below).`;
    case 'finished':
      return e.payload?.outcome === 'cancelled' ? 'Cancelled. The answer uses what was done before the cancel.' : `Finished: ${String(e.payload?.outcome ?? '')}.`;
    default:
      return null;
  }
}

/** What an answer box shows: only typed text. A chosen option, such as the default, shows on its chip. */
export function typedText(slot: Ask['slots'][number], value: string | undefined): string {
  return value === undefined || slot.options.some((o) => o.value === value) ? '' : value;
}
